import React, { ReactNode } from 'react';
import { TProviders } from '../../models/order-details/track-shipment';

// TODO: move this to constant file
const UPS_LOGO_SRC =
  'https://assets.thdstatic.com/images/v1/shipping-carriers/ups-logo.svg';
const FEDEX_LOGO_SRC =
  'https://assets.thdstatic.com/images/v1/shipping-carriers/FEDEX.png';
const ESTES_LOGO_SRC =
  'https://assets.thdstatic.com/images/v1/shipping-carriers/Estes.png';
const ONTRAC_LOGO_SRC =
  'https://assets.thdstatic.com/images/v1/shipping-carriers/ontrac.svg';

const SEKO_LOGO_SRC =
  'https://assets.thdstatic.com/images/v1/shipping-carriers/seko.png';
const YRC_LOGO_SRC =
  'https://assets.thdstatic.com/images/v1/shipping-carriers/YRC_Freight.png';

const USPS_LOGO_SRC =
  'https://assets.thdstatic.com/images/v1/shipping-carriers/usps-logo.svg';
const US_PACK_LOGO_SRC =
  'https://assets.thdstatic.com/images/v1/shipping-carriers/USPack.png';

export const trackingProviderImages = (providerCode: string) => {
  switch (providerCode) {
    case 'UPS':
    case 'UPS1':
    case 'UPSC':
    case 'UPSN':
      return UPS_LOGO_SRC;

    case 'USPS':
      return USPS_LOGO_SRC;

    case 'BESY':
      return US_PACK_LOGO_SRC;

    case 'FEDEX':
    case 'FED':
    case 'FDEG':
    case 'FDEN':
    case 'FEDE':
    case 'FXHD':
    case 'FXNL':
    case 'FXSP':
      return FEDEX_LOGO_SRC;

    case 'EST':
    case 'EXLA':
      return ESTES_LOGO_SRC;

    case 'ONT':
    case 'EMSY':
      return ONTRAC_LOGO_SRC;

    case 'SEK':
    case 'SEKW':
      return SEKO_LOGO_SRC;

    case 'YRC':
    case 'RWY':
    case 'YFSY':
      return YRC_LOGO_SRC;
    default:
      return null;
  }
};

export const getProviderImage = (providerCode: TProviders | ''): ReactNode => {
  const provider = trackingProviderImages(providerCode);
  // TODO: fix the imageWidth by changing the static images on thd-static-assets which has same sizes. Currently, UPS Logo is larger than any other logo's available
  const imageWidth = ['UPS', 'UPS1', 'UPSC', 'UPSN'].some((code) =>
    providerCode.includes(code),
  )
    ? '10%'
    : '20%';
  if (!provider) {
    return null;
  }
  return (
    <img
      height="24px"
      width={imageWidth}
      alt="shipping-carrier-logo"
      src={provider}
      loading="lazy"
      decoding="async"
    />
  );
};
